import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { promoCodes } from 'src/constants/promoCodes'
import { commonSubtitleText, commonTitleText } from 'src/modules/utils/constants'

export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    title={commonTitleText.streamLiveTVSports}
    subtitle={commonSubtitleText.onAnyDevice}
    showRSN={true}
    offerCode={promoCodes.crunch}
    offerBanner={{
      title: ['Special offer from Crunch Fitness:', 'Enjoy 5 days FREE + 25% off your first month'],
    }}
    logoHeight={'90px'}
    logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-crunch-2.png?w=451&ch=width&auto=format,compress"
    noIndex={true}
  />
)
